/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/main/LICENSE.md for details.
 * v1.9.2
 */
import { A as Action, d as defineCustomElement$1 } from './action.js';

const CalciteAction = Action;
const defineCustomElement = defineCustomElement$1;

export { CalciteAction, defineCustomElement };
